import { useEffect, useState } from 'react';
import { SUBSCRIPTION_TYPES_MAP } from '@utils/constants';
import { useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { useGetAlert } from './hooks/useGetAlert';
import { Icon } from '@iconify/react';
import { Alert } from '@interfaces/general';

export const CommunicationsBar = () => {
  const [openBars, setOpenBars] = useState<Record<string, boolean>>({});
  const { planId } = useSubscription();
  const planLabel = SUBSCRIPTION_TYPES_MAP[planId]?.label;
  const formattedDate = new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'America/Mexico_City',
  }).format(new Date());
  const { alerts } = useGetAlert({
    date: formattedDate,
    plan: planLabel,
  });

  const handleCloseBar = (uuid: string) => {
    setOpenBars((prev) => ({ ...prev, [uuid]: false }));
  };

  useEffect(() => {
    if (!alerts || alerts.length === 0) return;

    const newOpenBars: Record<string, boolean> = {};
    const timers: Record<string, ReturnType<typeof setTimeout>> = {};

    alerts.forEach((alert) => {
      if (!alert.uuid) return;

      const { uuid, show_once, has_display_time_limit, delay_before_close } = alert;
      const hasBeenShown = localStorage.getItem(`alert_${uuid}`);

      if (!show_once || !hasBeenShown) {
        newOpenBars[uuid] = true;

        if (show_once) {
          localStorage.setItem(`alert_${uuid}`, 'true');
        }

        if (has_display_time_limit && delay_before_close) {
          timers[uuid] = setTimeout(() => {
            handleCloseBar(uuid);
          }, delay_before_close);
        }
      }
    });

    setOpenBars((prev) => ({ ...prev, ...newOpenBars }));

    return () => {
      Object.values(timers).forEach((timer) => clearTimeout(timer));
    };
  }, [alerts]);

  const handleBarClick = (alert: Alert) => {
    if (alert.url) {
      window.open(alert.url, '_blank');
    }
  };

  if (!alerts || alerts.length === 0) {
    return null;
  }

  const visibleAlerts = alerts.filter((alert) => alert.uuid && openBars[alert.uuid]);

  return (
    <>
      {visibleAlerts.map((alert, index) => (
        <div
          key={alert.uuid}
          className={`fixed bottom-0 left-0 right-0 px-4 py-2 hover:cursor-pointer hover:bg-opacity-90 transition-opacity z-50 ${alert.bg_color?.startsWith('#') ? '' : alert.bg_color}`}
          style={{
            backgroundColor: alert.bg_color?.startsWith('#') ? alert.bg_color : undefined,
            bottom: `${index * 40}px`,
          }}
          onClick={() => handleBarClick(alert)}
        >
          <div className="flex items-center gap-x-2 text-sm md:text-base" style={{ color: alert.text_color }}>
            <Icon icon="material-symbols:warning" />
            <span className="font-bold w-full text-justify">{alert.text}</span>
          </div>
        </div>
      ))}
    </>
  );
};
